var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Copy Service Log" } }),
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass: "page-container",
          class: { "mobile pa-4": _vm.isMobile, "py-4 px-5": _vm.isTablet }
        },
        [
          _c("student-card", { attrs: { student: _vm.student } }),
          _vm._v(" "),
          _c("service-log-form", {
            attrs: {
              showTooltip: _vm.showTooltip,
              student: _vm.student,
              loadData: _vm.loadData,
              medicaidArray: _vm.medicaidArray,
              absentTypesArray: _vm.absentTypesArray,
              absentReasonsArray: _vm.absentReasonsArray,
              absentAlternativesArray: _vm.absentAlternativesArray,
              groupTypeArray: _vm.groupTypeArray,
              deliveryModeArray: _vm.deliveryModeArray,
              serviceDeliveredArray: _vm.serviceDeliveredArray,
              index: 1,
              arrayLength: 1,
              action: "copy"
            },
            on: {
              "form:submitted": function($event) {
                _vm.submitted = true
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e(),
      _vm._v(" "),
      _c("bottom-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d643ef1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d643ef1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service-log/copy-service-log.vue
// module id = null
// module chunks = 